import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import Crum from '@/components/Crum';
import SupportTitle from '@/components/SupportCommon/SupportTitle';
import SupportContactUs from '@/components/SupportCommon/SupportContactUs';
import SupportLeftMenu from '@/components/SupportCommon/SupportLeftMenu';
import SupportMenu from '@/componentsH5/SupportCommon/SupportMenu';
//import SupportBannerPc from '@/components/SupportCommon/SupportBanner';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import Pagination from '@/components/UI/Pagination';
import { getFaqCatagoryTree, getFaqs } from '@/service';
import { isReadyLang, redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import Empty from '@/components/Search/Empty';
import CustomSpin from '@/components/UI/CustomSpin';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/support/faq';

const SupportBannerPc = dynamic(() => import('@/components/SupportCommon/SupportBanner'), {
    ssr: true,
});

let paramsTemp = {}; //分页查询使用
export default function SupportProduct({ categoryTree, lang, SEO }: any) {
    const { useState, useEffect, isMobile, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const filterCataTree = (tree: any) => {
        tree?.map((treeList: any) => {
            if (treeList?.name === 'Portable Power Stations') {
                treeList?.subs?.map((sub: any) => {
                    if (sub?.name === 'RIVER Series') {
                        const restSubs = sub?.subs?.filter((item: any) => !['RIVER 2 Pro', 'RIVER 2 Max'].includes(item?.name));
                        sub.subs = restSubs || [];
                    }
                });
            }
        });
        return tree;
    };
    // 2022-10-18: river2max river2pro 不展示
    const [newCataTree, setNewCataTree] = useState(filterCataTree(JSON.parse(JSON.stringify(categoryTree))));
    const SupportBanner = isMobile ? SupportBannerH5 : SupportBannerPc;
    const [isFirstIn, setIsFitstIn] = useState(true); // 是否首次进入页面（未发送请求）
    const [faqList, setFaqList] = useState([]);
    const [pageInfo, setPageInfo] = useState({
        page: 1,
        size: 5,
        total: 0,
    });
    const { t } = useLang('shared');
    const breadcrumbData = [
        { name: t('crums.crum_home'), link: '/' },
        { name: t('crums.crum_support'), link: '/support' },
        { name: t('crums.crum_product_faq') },
    ];
    const [loading, setLoading] = useState(false);

    /**
     * 获取所有产品目录id(faqCatagoryType为PRODUCT_CATAGORY)
     */
    const getAllIds = (categoryTree: any, idArr: string[] = []) => {
        categoryTree.forEach((item: any) => {
            if (item.faqCatagoryType === 'PRODUCT_CATAGORY') {
                idArr.push(item.faqCatagoryId);
                if (item.subs) {
                    getAllIds(item.subs, idArr);
                }
            }
        });
        return idArr;
    };

    // 分页查询
    const handlePageChange = (page: number) => {
        getFaqList({
            ...paramsTemp,
            page,
        }).finally(() => {
            setPageInfo({ ...pageInfo, page });
        });
    };

    // 获取faq列表
    const getFaqList = async (params: any) => {
        setLoading(true);
        const { page } = params;
        paramsTemp = params; // 缓存搜索条件
        try {
            const res = await getFaqs({ ...params, size: pageInfo.size });
            setLoading(false);
            setIsFitstIn(false);
            if (res.code === '0') {
                setFaqList(res.data?.content || []);
                setPageInfo({ ...pageInfo, total: res.data?.total || 0, page: page || 1 });
            }
        } catch (e) {
            setLoading(false);
            setFaqList([]);
            setPageInfo({ ...pageInfo, total: 0, page: 1 });
        }
    };

    useEffect(() => {
        if (isMobile) {
            if (newCataTree[0] && !newCataTree[0]?.subs?.length) {
                getFaqList({ productCatagoryIds: newCataTree[0].faqCatagoryId }).catch(() => setIsFitstIn(false));
            }
            if (newCataTree[0] && newCataTree[0]?.subs?.length && !newCataTree[0]?.subs[0]?.subs?.length) {
                if (newCataTree[0]?.subs[0].faqCatagoryType === 'PRODUCT_CATAGORY') {
                    getFaqList({ productCatagoryIds: newCataTree[0].subs[0].faqCatagoryId }).catch(() => setIsFitstIn(false));
                }
                if (newCataTree[0]?.subs[0].faqCatagoryType === 'SPU') {
                    getFaqList({ spuIds: newCataTree[0].subs[0].faqCatagoryId }).catch(() => setIsFitstIn(false));
                }
            }
            if (newCataTree[0] && newCataTree[0]?.subs?.length && newCataTree[0]?.subs[0]?.subs?.length) {
                getFaqList({ spuIds: newCataTree[0].subs[0].subs[0].faqCatagoryId }).catch(() => setIsFitstIn(false));
            }
        } else {
            getFaqList({ productCatagoryIds: getAllIds(newCataTree).join() }).catch(() => setIsFitstIn(false));
        }
        setNewCataTree(newCataTree);
    }, [isMobile]);

    return (
        <PageLayout style={{ backgroundColor: '#fff' }}>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <SupportBanner />
            <Crum data={breadcrumbData} />
            <div className={css.faqContainer}>
                <div className="faq-content">
                    <SupportTitle title={lang.site_support_faq} />
                    {isMobile && (
                        <SupportMenu
                            categoryTree={newCataTree}
                            fieldNames={{
                                title: 'name',
                                value: 'faqCatagoryId',
                                children: 'subs',
                                type: 'faqCatagoryType',
                            }}
                            onSelect={(ids: string, type: string) =>
                                getFaqList(
                                    type === 'PRODUCT_CATAGORY'
                                        ? { productCatagoryIds: ids }
                                        : type === 'SPU'
                                        ? { spuIds: ids }
                                        : type === 'SKU'
                                        ? { skuIds: ids }
                                        : type === 'SN'
                                        ? { snInSkuIds: ids }
                                        : { catagoryIdsStr: ids },
                                )
                            }
                        />
                    )}
                    <div className="faq-list" style={{ display: isMobile ? 'block' : 'flex' }}>
                        {/*左侧菜单栏*/}
                        {!isMobile && (
                            <SupportLeftMenu
                                categoryTree={newCataTree}
                                fieldNames={{
                                    title: 'name',
                                    value: 'faqCatagoryId',
                                    children: 'subs',
                                    type: 'faqCatagoryType',
                                }}
                                onSearch={(title: string) =>
                                    getFaqList({
                                        title,
                                    })
                                }
                                onSelect={(ids: string, type: string) =>
                                    getFaqList(
                                        type === 'PRODUCT_CATAGORY'
                                            ? { productCatagoryIds: ids }
                                            : type === 'SPU'
                                            ? { spuIds: ids }
                                            : type === 'SKU'
                                            ? { skuIds: ids }
                                            : type === 'SN'
                                            ? { snInSkuIds: ids }
                                            : { catagoryIdsStr: ids },
                                    )
                                }
                            />
                        )}

                        {/*右侧content*/}
                        <div className="faqs" style={{ display: faqList?.length ? '' : 'none' }}>
                            <CustomSpin loading={loading} />
                            <div style={{ opacity: !loading ? 1 : 0 }}>
                                {faqList?.map((faq: any, index: number) => (
                                    <div key={index} className="faqItem">
                                        <h3>{faq.title}</h3>
                                        <p className="font-family-regular">{faq.description}</p>
                                    </div>
                                ))}
                            </div>
                            <div className="page-content">
                                <Pagination
                                    className="page"
                                    current={pageInfo.page}
                                    pageSize={pageInfo.size}
                                    total={pageInfo.total}
                                    hideOnSinglePage={true}
                                    showSizeChanger={false}
                                    onChange={handlePageChange}
                                />
                            </div>
                        </div>

                        {/* 无结果 */}
                        {(!Array.isArray(faqList) || faqList.length === 0) && !isFirstIn && <Empty isMobile={isMobile} />}
                    </div>
                    <SupportContactUs isShow={true} />
                </div>
            </div>
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: any) {
    if (!isReadyLang(locale)) {
        return redirectTo404(locale);
    }
    const categoryTreeRes = await getFaqCatagoryTree(locale);

    return {
        props: {
            categoryTree: categoryTreeRes?.data || [],
        },
    };
}
